import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=b6ba56dc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=b6ba56dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ba56dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6ba56dc')) {
      api.createRecord('b6ba56dc', component.options)
    } else {
      api.reload('b6ba56dc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=b6ba56dc&scoped=true&", function () {
      api.rerender('b6ba56dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21QE22aZ8kDkx/JS/comp/PopupBox.vue"
export default component.exports